export default __webpack_public_path__ + "static/media/Medium's Armbands of Consumed Souls.0389bc06.jpg";